import React from 'react';
import Header from '../../components/header/header';
import './give.scss';
import { Link } from 'react-router-dom';
import { motion } from "motion/react";

const Give = () => {
  // const copyToClipboard = (text) => {
  //   navigator.clipboard.writeText(text).then(() => {
  //     alert('Copied to clipboard!');
  //   }).catch(err => {
  //     console.error('Failed to copy: ', err);
  //   });
  // };

  return (
    <div className="give">
      <Header />
    <div className='give-container'>
      {/* Hero Section */}
      <section className="hero3">
        <div className="hero-content3">
          <h1>Give</h1>
          <p>Your generosity makes a lasting impact in our community and around the world. Thank you for partnering with us in ministry.</p>
        </div>
      </section>

      {/* Give Methods Section - Fade in from top */}
      <motion.section
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
      >
        <div className="section-header3">
          <h2 className="section-title3">Ways to Give</h2>
          <p className="section-subtitle3">Choose the giving method that works best for you. Every gift, no matter the size, makes a difference.</p>
        </div>

        <div className="give-methods">
          {/* Give Online via Zelle */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="give-card"
          >
            <div className="give-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
              </svg>
            </div>
            <h3>Give via Zelle</h3>
            <p>Send your donation securely using Zelle through your banking app. Please include your name in the reference.</p>
            
            <div className="banking-details">
              <div style={{ padding: '1rem', textAlign: 'center' }}>
                <div>
                  <span style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--primary-blue)' }}>rccgmiddletown@yahoo.com</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Give by Text */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="give-card"
          >
            <div className="give-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"/>
              </svg>
            </div>
            <h3>Give by Text</h3>
            <p>Give quickly and securely using your mobile phone. Simply text your gift amount to the number below and follow the prompts.</p>
            
            <div className="banking-details">
              <div style={{ padding: '1rem', textAlign: 'center' }}>
                <div style={{ background: 'var(--white)', padding: '1rem', borderRadius: '6px', marginBottom: '1rem' }}>
                  <span style={{ display: 'block', fontSize: '0.9rem', fontWeight: '700', color: 'var(--primary-blue)', fontFamily: 'DM Sans, monospace' }}>(302) 402-5100</span>
                </div>
                <p style={{ margin: '0', fontSize: '0.9rem', color: 'var(--gray-600)' }}>Example: Text <strong>50</strong> to give $50</p>
              </div>
            </div>
          </motion.div>

          {/* Check/Mail */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="give-card"
          >
            <div className="give-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
              </svg>
            </div>
            <h3>Mail a Check</h3>
            <p>Make checks payable to "RCCG Amazing Grace" and mail to:</p>
            
            <div className="banking-details">
              <div style={{ padding: '1rem', textAlign: 'center' }}>
                <strong style={{ display: 'block', marginBottom: '0.5rem', color: 'var(--black)' }}>RCCG Amazing Grace</strong>
                <span style={{ display: 'block', color: 'var(--gray-700)' }}>211 E Main St</span>
                <span style={{ display: 'block', color: 'var(--gray-700)' }}>Middletown, DE 19709</span>
              </div>
            </div>
          </motion.div>

          {/* Give Online via Church App */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="give-card"
          >
            <div className="give-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
              </svg>
            </div>
            <h3>Give via Church App</h3>
            <p>Give your donations, and stay connected through the RCCG Amazing Grace mobile app.</p>
            
            <div className="banking-details">
              <div style={{ padding: '1rem', textAlign: 'center' }}>
                <strong style={{ display: 'block', color: 'var(--black)', marginBottom: '1rem' }}>RCCG Amazing Grace</strong>
                <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
                  <Link to='https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https://apps.apple.com/ua/app/rccgagc/id1634455168&ved=2ahUKEwiU-bWx2cqSAxUmd0EAHf2iBGgQFnoECBoQAQ&usg=AOvVaw1oG7At2-00Sjox1q3KL8aT' className="copy-btn" style={{ flex: '1', maxWidth: '130px' }}>App Store</Link>
                  <Link to='https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https://play.google.com/store/apps/details%3Fid%3Dcom.churchpad.rccgagc%26hl%3Den_GB&ved=2ahUKEwiU-bWx2cqSAxUmd0EAHf2iBGgQFnoECBsQAQ&usg=AOvVaw0rJPF-xUy3C2fZun693zEZ' className="copy-btn" style={{ flex: '1', maxWidth: '130px' }}>Google Play</Link>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.section>

      {/* Current Projects Section - Slide from left */}
      {/* <motion.section 
        initial={{ opacity: 0, x: -60 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.8 }}
        style={{ background: 'var(--gray-50)', padding: '5rem 4%' }}
      >
        <div className="section-header3">
          <h2 className="section-title3">Current Projects & Initiatives</h2>
          <p className="section-subtitle3">Support specific projects that are transforming lives in our community and beyond.</p>
        </div>

        <div className="projects-grid">
          {[
            {
              img: "https://images.pexels.com/photos/35404499/pexels-photo-35404499.jpeg",
              tag: "BUILDING FUND",
              title: "Church Expansion Project",
              desc: "Help us create more space for worship, fellowship, and ministry. Our growing congregation needs a larger facility to accommodate families and expand our outreach programs."
            },
            {
              img: "https://images.pexels.com/photos/6646879/pexels-photo-6646879.jpeg",
              tag: "CHARITY",
              title: "Community Food Program",
              desc: "Monthly food distribution to families in need within our community. We provide groceries, fresh produce, and essential items to over 150 families each month."
            },
            {
              img: "https://images.pexels.com/photos/9037222/pexels-photo-9037222.jpeg",
              tag: "MISSIONS",
              title: "Global Missions Support",
              desc: "Supporting missionaries and church planting efforts around the world. Your gifts help spread the Gospel and establish churches in unreached communities."
            },
            {
              img: "https://images.pexels.com/photos/6275774/pexels-photo-6275774.jpeg",
              tag: "YOUTH",
              title: "Youth Ministry Programs",
              desc: "Investing in the next generation through weekly gatherings, summer camps, leadership training, and mentorship programs for teens and young adults."
            },
            {
              img: "https://images.pexels.com/photos/7520766/pexels-photo-7520766.jpeg",
              tag: "CHILDREN",
              title: "Children's Ministry Resources",
              desc: "Providing quality Bible curriculum, teaching materials, toys, and equipment for our growing children's ministry. Creating a safe and engaging environment for kids."
            }
          ].map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="project-card"
            >
              <div className="project-image">
                <img src={project.img} alt="Community Outreach" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div className="project-content">
                <span className="project-tag">{project.tag}</span>
                <h3>{project.title}</h3>
                <p>{project.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.section> */}

      {/* FAQ Section - Blur to focus */}
      <motion.section
        initial={{ opacity: 0, filter: "blur(8px)" }}
        whileInView={{ opacity: 1, filter: "blur(0px)" }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
        className='g-down'
      >
        <div className="section-header">
          <h2 className="section-title">Questions About Giving</h2>
        </div>

        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {[
            {
              question: "How will my donation be used?",
              answer: "All donations go directly toward ministry operations, community outreach, missions support, and facility maintenance. We are committed to transparency and faithful stewardship of every gift."
            },
            {
              question: "Can I designate my gift to a specific project?",
              answer: "Yes! When making your donation, please indicate which project you would like to support in the memo or reference field. Undesignated gifts support general ministry operations."
            },
            {
              question: "Will I receive a tax receipt?",
              answer: "Yes, you will receive a receipt for all donations. Annual giving statements are mailed in January for tax purposes."
            },
            {
              question: "How can I set up recurring giving?",
              answer: "Contact our church office at (302) 465-0760 or email us to set up automatic monthly donations through bank transfer."
            }
          ].map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="info-box"
            >
              <h4>{faq.question}</h4>
              <p>{faq.answer}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>
      </div>
    </div>
  );
};

export default Give;
